import { EnvService } from "./env.service";
import { AppConfigService } from '../config/app-config.service';

export const EnvServiceProvider = {
    provide: EnvService,
    useFactory: (config: AppConfigService): EnvService => config.hosts,
    deps: [AppConfigService]
};
